import { stringNumberToNumber, removeSpacesFromString, plural } from './helpers';

const pluralize = async () => {
    const targets = document.querySelectorAll('.js-pluralize');
    for (let i = 0; i < targets.length; i++) {
        const target = targets[i];
        let { forms, num } = target.dataset;

        if (!forms || !num) {
            return false;
        }
        forms = removeSpacesFromString(forms).split(',');
        num = stringNumberToNumber(num);
        target.textContent = `${num} ${plural(forms, num)}`;
    }
};

export default pluralize;
